<template>
  <div class="p-6 flex items-center justify-center">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">

            <div class="text-left mb-2">
              <p class="mb-2 font-medium text-lg text-gray-800">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>
              <div class="flex justify-center">
                <img
                  v-if="selectedFileUrl || store.image"
                  :src="selectedFileUrl ?? fileUrl + store.image"
                  alt="Logo"
                  class="mt-8 mb-auto rounded-md w-60 max-h-60 hidden md:block"
                />
              </div>
            </div>

            <div class="lg:col-span-2">
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">
                <!-- nome -->
                <div class="md:col-span-3">
                  <BaseInput
                    v-model="store.name"
                    name="name"
                    :info="'Informe o nome do colaborador'"
                    label="Nome"
                    :required-field="true"
                    type="text"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.name = null"
                      />
                    </template>
                  </BaseInput>

                  <span name="name" class="text-red-600 text-sm" />
                </div>

                <!-- celular -->
                <div class="md:col-span-2">
                  <BaseInput
                    v-model="store.phone"
                    name="phone"
                    v-mask="'(##) # ####-####'"
                    :info="'Número para contato'"
                    label="Celular"
                    type="text"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.phone = null"
                      />
                    </template>
                  </BaseInput>
                </div>

                <!-- email -->
                <div class="md:col-span-3">
                  <BaseInput
                    v-model="store.email"
                    name="email"
                    :info="'Email da conta'"
                    label="Email de acesso"
                    :required-field="true"
                    type="email"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.email = null"
                      />
                    </template>
                  </BaseInput>

                  <span name="email" class="text-red-600 text-sm" />
                </div>

                <!-- serviços -->
                <div class="md:col-span-2">
                  <BaseInput
                    v-model="store.role"
                    name="role"
                    :info="'Informe os serviços que realiza'"
                    label="Serviços"
                    :required-field="true"
                    type="email"
                  >
                    <template #append>
                      <CleanInputButton
                        @click="store.role = null"
                      />
                    </template>
                  </BaseInput>
                  <span name="role" class="text-red-600 text-sm" />
                </div>

                <!-- imagem -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl"
                    :src="selectedFileUrl"
                    alt="Logo"
                    class="mt-2 rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <!-- imagem -->
                <div class="md:col-span-5 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[10rem] pt-2.5 h-10 rounded-l-md rounded-r-none"
                  >
                    <i class="fa-solid fa-building text-blueGray-600"></i>
                    Foto do funcionario
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="p-2 mt-1 mb-1" />

        <div>
          <slot />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/Inputs/BaseInput.vue'
import CleanInputButton from '../components/CleanInputButton.vue'
import { dataCollab } from '../store/'
import * as toast from '@/helpers/useToast'

export default {
  name: 'FormVue',
  components: {
    CleanInputButton,
    BaseInput
  },
  props: {
    descriptionTitle: String
  },
  data () {
    const store = dataCollab.state
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'

    return {
      store,
      toast,
      fileUrl,
      selectedFileName: undefined,
      selectedFileUrl: undefined
    }
  },
  methods: {
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()

        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)
          this.store.image = file
        } else {
          this.selectedFileUrl = undefined
          this.selectedFileName = undefined
          this.store.image = undefined
          return this.toast.showToast(
            'Erro',
            'Tipo de arquivo não é válido !',
            'error'
          )
        }
      }
    }
  }
}
</script>
